<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M19.2572 11.0527H16.5271V8.42888H19.2572C19.6675 8.42888 20 8.09668 20 7.68637C20 7.27603 19.6675 6.94362 19.2572 6.94362H16.5271V3.30288C16.5271 2.77143 16.4221 2.38135 16.2151 2.14374C16.0183 1.91769 15.7596 1.8125 15.4014 1.8125C15.0595 1.8125 14.8106 1.91696 14.6176 2.1416C14.413 2.37946 14.3092 2.77026 14.3092 3.30312V6.94406H9.17366L6.9901 3.63984C6.80322 3.34496 6.62751 3.06873 6.45687 2.80359C6.30324 2.5648 6.1534 2.37039 6.01187 2.22523C5.88657 2.0967 5.74378 1.99724 5.57677 1.92079C5.41919 1.84885 5.21886 1.81274 4.98184 1.81274C4.67954 1.81274 4.40513 1.89556 4.14237 2.06571C3.88234 2.23401 3.7026 2.44209 3.59282 2.70187C3.49646 2.94875 3.44548 3.32706 3.44548 3.81539V6.94382H0.742471C0.332324 6.94386 0 7.27627 0 7.68657C0 8.09688 0.332324 8.42909 0.742511 8.42909H3.44552V11.0532H0.742511C0.332324 11.0532 0 11.3855 0 11.796C0 12.2062 0.332324 12.5382 0.742511 12.5382H3.44552V16.695C3.44552 17.2108 3.55389 17.5969 3.76853 17.8423C3.97266 18.0762 4.23147 18.1848 4.58294 18.1848C4.92204 18.1848 5.17884 18.0757 5.39179 17.8413C5.60986 17.6012 5.72016 17.2153 5.72016 16.6951V12.5382H10.3672L12.882 16.3944C13.0569 16.6493 13.2374 16.9066 13.4175 17.1589C13.5799 17.3854 13.7572 17.585 13.9442 17.7517C14.1126 17.9025 14.2931 18.0131 14.4808 18.0805C14.674 18.15 14.8998 18.1853 15.1504 18.1853C15.8305 18.1853 16.527 17.9771 16.527 16.433V12.5382H19.2572C19.6674 12.5382 19.9999 12.2057 19.9999 11.7955C20 11.3853 19.6675 11.0527 19.2572 11.0527ZM14.3091 8.42884V11.0527H11.8894L10.1556 8.42884H14.3091ZM5.7202 5.41394L6.71806 6.94362H5.7202V5.41394ZM5.7202 11.0527V8.42888H7.68699L9.39842 11.0527H5.7202ZM14.3091 14.715L12.8711 12.5382H14.3091V14.715Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'NairaIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>